import gql from "graphql-tag";

// eslint-disable-next-line import/no-default-export
export const SAVE_METADATA = gql`
	mutation saveMetaData($input: SaveMetaDataInput!) {
		saveMetaData(input: $input) {
			boolean
		}
	}
`;
